/* eslint-disable jsx-a11y/alt-text */
import { findMap } from '../helpers/drafting';
import classNames from 'classnames';

export function DraftMap({map, state, randomized, status, result}) {
    const selectedMap = findMap(map, { withFallback: true });

    const leftWon = result === 'left';
    const rightWon = result === 'right';
    const hasPlayed = leftWon || rightWon;
    const hasPicked = result === 'picked';

    return (
        <div className="draft__mapContainer">
            <img className={classNames(
                'draft__mapOption',
                `draft__map__${state}`,
                hasPlayed && 'draft__mapPlayed',
                hasPicked && 'draft__mapPicked'
                )} src={selectedMap.iconUrl} />
            {state === 'ban' && <img className='draft__mapBannedIcon' src="/civBanned.png" />}
            {leftWon && <img className='draft__mapLeftWonIcon' src="/civWon.svg" />}
            {rightWon && <img className='draft__mapRightWonIcon' src="/civWon.svg" />}
            {randomized && <img className={classNames('draft__mapRandomIcon', hasPlayed && 'draft__mapPlayed')} src="/random.png" />}
        </div>
    )
}
